<template>
<header>
  <nav class="navbar is-fixed-top is-primary" role="navigation" aria-label="menu principal">
    <div class="navbar-brand">
      <a class="navbar-item" href="https://www.parkings.mc/">
        <img src="https://cdn.parkings.mc/favicon/favicon-32x32.png" alt="monaco parkings: les parkings publics à monaco" width="28" height="28">
      </a>
      <a role="button" class="navbar-burger" :class="isMenuActive ? 'is-active' : ''" aria-label="menu" aria-expanded="false" @click="isMenuActive=!isMenuActive">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <!-- main navigation -->
    <div class="navbar-menu" :class="isMenuActive ? 'is-active' : ''">
      <div class="navbar-start">
        <a class="navbar-item is-active" href="https://maps.parkings.mc">
          <span class="icon">
            <svg class="svg-inline--fa fa-search fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="search" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="">
              <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path>
            </svg><!-- <i class="fas fa-search"></i> -->
          </span>
          <span>Trouver un parking</span>
        </a>
        <div class="navbar-item has-dropdown is-hoverable">
          <span class="navbar-link">
            Stationner
          </span>
          <div class="navbar-dropdown">
            <a class="navbar-item " href="https://www.parkings.mc/stationner-infos-generales-tarifs.html">
              Info. générales tarifs
            </a>
            <!-- <a class="navbar-item disable" href="http://www.parkings.mc/stationner-reservations-web.html"> Réservations web </a> -->
            <a class="navbar-item " href="https://www.parkings.mc/stationner-conditions-abonnement.html">
              Conditions d'abonnement
            </a>
            <a class="navbar-item " href="https://www.parkings.mc/stationner-courte-duree.html">
              Courte durée
            </a>
            <a class="navbar-item " href="https://www.parkings.mc/stationner-stations-de-lavage.html">
              Stations de lavage
            </a>
            <a class="navbar-item " href="https://www.parkings.mc/stationner-stations-de-rechargement.html">
              Stations de rechargement
            </a>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Se déplacer
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item" href="https://www.parkings.mc/se-deplacer-bus.html">
              Bus
            </a>
            <a class="navbar-item" href="https://www.parkings.mc/se-deplacer-velos.html">
              Vélos
            </a>
            <a class="navbar-item" href="https://www.parkings.mc/se-deplacer-auto-partage-mobee.html">
              Auto-partage MOBEE
            </a>
          </div>
        </div>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="field is-grouped">
            <p class="control">
              <a class="button is-link" href="https://client.parkings.mc">
                <b-icon icon="user-circle"/>
                <span>Se connecter</span>
              </a>
            </p>
          </div>
        </div>

      </div>
    </div>
  </nav>
</header>
</template>

<script>
export default {
  data () {
    return {
      isMenuActive: false
    };
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue